import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import config from './config'
import jwtDecode from 'jwt-decode'
import moment from 'moment'


Vue.use(Router, axios, config)


const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/billing',
            name: 'billing',
            component: () => import('./views/Billing')
        },
        {
            path: '/marketing',
            name: 'marketing',
            component: () => import('./views/Marketing')
        },
        {
            path: '/setting/legal',
            name: 'legal_page',
            component: () => import('./views/LegalPage')
        },
        {
            path: '/marketing/facebook',
            name: 'marketing_facebook',
            component: () => import('./views/MarketingFacebook')
        },
        {
            path: '/marketing/amazon',
            name: 'marketing_amazon',
            component: () => import('./views/MarketingAmazon')
        },
        {
            path: '/marketing/amazon/template',
            name: 'marketing_amazon_template',
            component: () => import('./components/AmazonTemplate')
        },
        {
            path: '/price-table',
            name: 'price_table',
            component: () => import('./views/PriceTable')
        },
        {
            path: '/',
            name: 'home',
            component: () => import('./views/Home')
        },
        {
            path: '/home',
            name: 'home_x',
            component: () => import('./views/Home')
        },
        {
            path: '/logout',
            name: 'logout',

        },
        {
            path: '/login',
            name: 'login',

        },
        {
            path: '/setting',
            name: 'setting',
            component: () => import('./views/Setting')
        },
        {
            path: '/order',
            name: 'order',
            component: () => import('./views/Order')
        },

        {
            path: '/order/:id',
            name: 'order_detail',
            component: () => import('./views/OrderDetail')
        },

        {
            path: '/store',
            name: 'store',
            component: () => import('./views/Store')
        },
        {
            path: '/store/menu',
            name: 'store_menu',
            component: () => import('./views/StoreMenu')
        },
        {
            path: '/store/theme',
            name: 'store_theme',
            component: () => import('./views/StoreTheme')
        },
        {
            path: '/email',
            name: 'email',
            component: () => import('./views/Email')
        },
        {
            path: '/collection/:id',
            name: 'edit_collection',
            component: () => import('./views/EditCollection')
        },
        {
            path: '/payment',
            name: 'payment',
            component: () => import('./views/Payment')
        },
        {
            path: '/fulfillment',
            name: 'fulfillment',
            component: () => import('./views/Fulfillment')
        },
        {
            path: '/fulfillment/import',
            name: 'fulfillment_import',
            component: () => import('./views/ImportOrder')
        },
        {
            path: '/fulfillment/template',
            name: 'fulfillment_template',
            component: () => import('./views/FulfillmentTemplate')
        },
        {
            path: '/fulfillment/:id',
            name: 'fulfillment_detail',
            component: () => import('./views/FulfillmentDetail')
        },

        {
            path: '/campaign',
            name: 'campaign',
            component: () => import('./views/Campaign')
        },
        {
            path: '/campaign/create',
            name: 'create_campaign',
            component: () => import('./views/CreateCampaign')
        },

        {
            path: '/campaign/:id',
            name: 'edit_campaign',
            component: () => import('./views/EditCampaign')
        },

        {
            path: '/campaign/bulk/:id',
            name: 'bulk_clone',
            component: () => import('./views/BulkClone')
        },
        {
            path: '/promotion',
            name: 'promotion',
            component: () => import('./views/Promotion')
        },
        {
            path: '/customer',
            name: 'customer',
            component: () => import('./views/Customer')
        },
        {
            path: '/analytic',
            name: 'analytic',
            component: () => import('./views/Analytic')
        },
        {
            path: '/integrate/woocommerce',
            name: 'integrate_woocommerce',
            component: () => import('./views/integrate/WooConnect')
        },
        {
            path: '/integrate/woocommerce/edit/:id',
            name: 'integrate_woocommerce_edit',
            component: () => import('./views/integrate/WooStoreEdit')
        },
        {
            path: '/integrate/etsy',
            name: 'integrate_etsy',
            component: () => import('./views/integrate/EtsyConnect')
        },
        {
            path: '/integrate/shopify',
            name: 'integrate_shopify',
            component: () => import('./views/integrate/ShopifyConnect')
        },
    ]
})


router.beforeEach(async (to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page

    if (to.name == 'logout') {
        localStorage.removeItem('access_token');
    }

    const publicPages = ['/login'];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = localStorage.getItem('access_token');
    //console.log(this.$root.$author.brand())

    //console.log(loggedIn)
    let isLogined = false
    if (loggedIn == null || loggedIn == '') {
        isLogined = false
    } else {
        isLogined = true
    }

    if (authRequired && isLogined == false) {
        return next('/login');

    } else {
        axios.defaults.headers.common['Authorization'] = loggedIn
        try {
            if (to.name != 'billing') {
                let user = jwtDecode(loggedIn)
                if (moment(user.expire_date) < moment()) {
                    return next('/billing');
                }
            }
        } catch (e) {
            console.log(e.message)
        }
        /*  try {
              let user = jwtDecode(loggedIn)
              //   console.log(loggedIn)
              //    console.log(user)

              //     axios.defaults.headers.common['Authorization'] = loggedIn

              if (moment(user.expire_date) < moment()) {
                  return next('/billing');
              }
          } catch (e) {
              console.log(e.message)
              //   return next('/login');

          }*/

    }
    next();
})

export default router
